<template lang="pug">
  el-card.box-processo(shadow="hover")
    h1 Gerenciar Chaves de Segurança
    div.containerForm
      el-form(ref="formChave" :model="chave" :rules="rules" label-position="top")
        el-form-item(label="Nome" prop="nome")
          el-input(v-model="chave.nome" placeholder="Digite o nome da chave")
        el-form-item(label="Chave de segurança" prop="chave")
          el-input(v-model="chave.chave" placeholder="Digite a chave")
        el-form-item(label="Tipo" prop="tipo")
          el-select(v-model="chave.tipo" placeholder="Selecione o tipo")
            el-option(v-for="tipo in tiposChave" :key="tipo" :label="tipo" :value="tipo")
        el-form-item(label="Usuário" prop="idUsuario")
          el-select(v-model="chave.idUsuario" placeholder="Selecione o usuário")
            el-option(v-for="usuario in usuarios" :key="usuario.id" :label="usuario.nome" :value="usuario.id")
        el-form-item
          el-button(type="primary" @click="saveChave") Salvar
          el-button(type="success" @click="gerarChave") Gerar Chave
    div.containerTodo
      div.containerCabecalho
        el-input(placeholder="Buscar chave por nome" v-model="filtroNome" @input="filtrarChaves")
      div.tabelaContainer
        el-table(:data="chavesFiltradas" border style="width: 100%")
          el-table-column(prop="nome" label="Nome")
          el-table-column(prop="tipo" label="Tipo")
          el-table-column(prop="chave" label="Chave")
          el-table-column(prop="data" label="Criado em" :formatter="formatarData")
          el-table-column(prop="ativa" label="Status")
            template(#default="{ row }")
              span(v-if="row.ativa" class="ativa") Ativa
              span(v-else class="inativa") Inativa
          el-table-column(label="Ações" width="250")
            template(#default="{ row }")
              el-button(size="small" type="success" v-if="!row.ativa" @click="alterarStatus(row.id, true)") Ativar
              el-button(size="small" type="danger" v-else @click="alterarStatus(row.id, false)") Desativar
              el-button(size="small" type="info" icon="el-icon-view" @click="abrirModalLogs(row.id)") Ver Logs

    el-dialog(title="Logs da Chave" :visible.sync="modalLogsVisivel" width="800px")
      el-table(:data="logs" border style="width: 100%")
        el-table-column(prop="data" label="Data" :formatter="formatarData")
        el-table-column(prop="ip" label="ip")
        el-table-column(prop="tipo" label="Tipo Acesso" )
      el-pagination(
        v-if="totalLogs > 0"
        @size-change="onSizeChange"
        @current-change="onPageChange"
        :current-page="pageable.page"
        :page-size="pageable.size"
        :total="totalLogs"
        layout="prev, pager, next"
      )
</template>

<script>
import { getChavesSeguranca, salvarChave, alterarStatusChave, buscarUsuariosPerfil, getLogsPorChave } from '../../utils/manutencao'
import AppNotificacao from '@/components/mixins/AppNotificacao'

export default {
  data () {
    return {
      chaves: [],
      usuarios: [],
      chavesFiltradas: [],
      logs: [],
      totalLogs: 0,
      modalLogsVisivel: false,
      chave: {
        nome: '',
        tipo: '',
        idUsuario: null,
        chave: ''
      },
      filtroNome: '',
      tiposChave: ['INTEGRACAO'],
      pageable: {
        page: 0,
        size: 10
      },
      idChaveAtual: null,
      rules: {
        chave: [{ required: true, message: 'A chave é obrigatória', trigger: 'blur' }],
        nome: [{ required: true, message: 'O nome é obrigatório', trigger: 'blur' }],
        tipo: [{ required: true, message: 'O tipo é obrigatório', trigger: 'change' }],
        idUsuario: [{ required: true, message: 'O usuário é obrigatório', trigger: 'change' }]
      }
    }
  },
  mixins: [AppNotificacao],
  async created () {
    await this.carregarChaves()
    await this.carregarUsuarios()
  },
  methods: {
    async carregarChaves () {
      try {
        this.chaves = await getChavesSeguranca()
        this.chavesFiltradas = this.chaves
      } catch (e) {
        this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR, 'Erro ao carregar as chaves de segurança')
      }
    },
    async carregarUsuarios () {
      try {
        this.usuarios = await buscarUsuariosPerfil('INTEGRACAO_EXTERNA')
      } catch (e) {
        this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR, 'Erro ao carregar usuários')
      }
    },
    async saveChave () {
      alert('fsdfsdfsd')
      this.$refs.formChave.validate(async (valid) => {
        if (valid) {
          try {
            await salvarChave(this.chave)
            this.showNotificacao(this.$messages.TIPO_SUCCESS, 'Sucesso', 'Chave salva com sucesso!')
            this.chave = { nome: '', tipo: '', idUsuario: null }
            await this.carregarChaves()
          } catch (e) {
            this.showNotificacao(this.$messages.TIPO_ERROR, 'Erro', 'Erro ao salvar a chave')
          }
        }
      })
    },
    gerarChave () {
      const caracteres = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
      let chaveGerada = ''
      for (let i = 0; i < 64; i++) {
        chaveGerada += caracteres.charAt(Math.floor(Math.random() * caracteres.length))
      }
      this.chave.chave = chaveGerada
    },
    filtrarChaves () {
      const filtro = this.filtroNome.toLowerCase()
      this.chavesFiltradas = this.chaves.filter(chave => chave.nome.toLowerCase().includes(filtro))
    },
    async alterarStatus (id, status) {
      try {
        await alterarStatusChave(id, status)
        this.showNotificacao(this.$messages.TIPO_SUCCESS, 'Sucesso', `Chave ${status ? 'ativada' : 'desativada'} com sucesso!`)
        await this.carregarChaves()
      } catch (e) {
        this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR, `Erro ao ${status ? 'ativar' : 'desativar'} a chave`)
      }
    },
    async abrirModalLogs (id) {
      this.idChaveAtual = id
      this.pageable.page = 0
      await this.carregarLogs()
      this.modalLogsVisivel = true
    },
    async carregarLogs () {
      try {
        const response = await getLogsPorChave(this.idChaveAtual, this.pageable)
        this.logs = response.content
        this.totalLogs = response.totalElements
      } catch (e) {
        this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR, 'Erro ao carregar logs')
      }
    },
    async onPageChange (page) {
      this.pageable.page = page
      await this.carregarLogs()
    },
    async onSizeChange (size) {
      this.pageable.size = size
      await this.carregarLogs()
    },
    formatarData (row, column, cellValue) {
      return new Date(cellValue).toLocaleString()
    }
  }
}
</script>

  <style lang="scss" scoped>
  .box-processo {
    min-width: 800px;
    padding: 15px;
  }

  .containerForm {
    margin-bottom: 15px;
  }

  .containerCabecalho {
    display: flex;
    justify-content: flex-start;
    margin-bottom: 15px;
  }

  .tabelaContainer {
    max-width: 100%;
  }

  .ativa {
    color: green;
    font-weight: bold;
  }

  .inativa {
    color: red;
    font-weight: bold;
  }
  </style>



// WEBPACK FOOTER //
// src/screens/manutencao/ChaveSeguranca.vue